<script>
export default {
  name: 'WapHeadline',
  props:{
    level:{
      type:Number,
      default:2
    }
  },
  render:function(h){
    let hn = h('h'+this.level,{class:'header'},'默认标题内容')
    if(this.$slots.default){
      hn = h('h'+this.level,{class:'header'},this.$slots.default)
    }
    return h('div',[hn,this.$slots.sub])
  }
};
</script>

<style lang="scss" scoped>

</style>